export const appConfig = {
    diasCuaderno: 15,
    maxNoches: 3,
    resources: 'https://resources.entrepyr.eu/',
    api: (process.env.NODE_ENV === 'development') ? 'entrepyr.eu' : location.hostname
}